// iAAM sister-platform definitions — single source of truth used by Footer,
// AppShell sidebar, and the top-bar dropdown.
export const SISTER_PLATFORMS = [
  {
    key: "airdrops-travels",
    name: "Airdrops Travels",
    tagline: "Travel for futurists.",
    description:
      "A technology-enabled travel platform that helps individuals, families, groups, and businesses discover, plan, and book affordable travel experiences from one convenient location.",
    url: "https://airdropstravels.com",
    logo: "/api/files/promos/airdrops-travels-icon.png",
    accent: "#E60012",
  },
  {
    key: "airdrops-punch",
    name: "Airdrops PUNCH",
    tagline: "Comprehensive Aerospace & Automotive Mobility.",
    description:
      "A CAAM platform connecting people, vehicles, services, technology, and future-mobility ecosystems through one integrated digital infrastructure. Available on iOS & Android.",
    url: "https://airdropspunch.com",
    logo: "/api/files/avatars/punch-ai.png",
    accent: "#00E5FF",
    badge: "iOS · ANDROID",
  },
];
